// Capsules strings to diferentiate closed or open
export const CLOSED_CAPSULE = 'Qmc7c9tNVaaAbTM5RMgdPY7MjPoLDFfPw8BAv3WuBUrebe'
// Not needed for the logic
export const OPEN_CAPSULE = 'QmZnvSyeKRQxWwcofVmq41BNCtHbBmomk8Ny8mtGRTjtzS'

//Paymaster
export const TESTNET_ETH_PAYMASTER_ADDRESS = ''
export const MAINNET_ETH_PAYMASTER_ADDRESS = ''

// Tokens
export const TESTNET_USDC_TOKEN_ADDRESS = '0x4b6021A15cB4E76DD40dE7B0d316A6a7fb613C05'
export const MAINNET_USDC_TOKEN_ADDRESS = '0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4'

// Oracle to get prices
export const PRICE_ETH_ID_ZKSYNC_MAINNET = '0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace'
export const PRICE_USDC_ID_ZKSYNC_MAINNET = '0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a'
export const PRICE_ETH_ID_ZKSYNC_TESTNET = '0xca80ba6dc32e08d06f1aa886011eed1d77c77be9eb761cc10d72b7d0a2fd57a6'
export const PRICE_USDC_ID_ZKSYNC_TESTNET = '0x41f3625971ca2ed2263e78573fe5ce23e13d2558ed3f2e47ab0f84fb9e7ae722'
